import { autosaveComponentModule } from './autosave/autosave';
import { autoSaveFormComponentModule } from './auto-save-form/auto-save-form';
import { autoUrlProtocolComponentModule } from './auto-url-protocol/auto-url-protocol';
import { buttonComponentModule } from './button/button';
import { formDataComponentModule } from './form-data/form-data';
import { formGroupComponentModule } from './form-group/form-group';
import { inputGroupRequiredComponentModule } from './input-group-required/input-group-required';
import { loginVerificationComponentModule } from './login-verification/login-verification';
import { markValidationComponentModule } from './mark-validation/mark-validation';
import { multilinePlaceholderComponentModule } from './multiline-placeholder/multiline-placeholder';
import { phoneNumberValidatorComponentModule } from './phone-number-validator/phone-number-validator';
import { scrollToErrorComponentModule } from './scroll-to-error/scroll-to-error';
import { selectComponentModule } from './select/select';
import { serverValidationErrorsComponentModule } from './server-validation-errors/server-validation-errors';
import { stopRouteChangeIfInvalidComponentModule } from './stop-route-change-if-invalid/stop-route-change-if-invalid';
import { tagsInputTabindexComponentModule } from './tags-input-tabindex/tags-input-tabindex';
import { uniqueEmailValidatorComponentModule } from './unique-email-validator/unique-email-validator';
import { warnOnChangesComponentModule } from './warn-on-changes/warn-on-changes';
import { autocompleteFixesComponentModule } from './autocomplete-fixes/autocomplete-fixes';

export const formsComponentModule = angular.module('Q.components.forms', [
  autosaveComponentModule,
  autoSaveFormComponentModule,
  autoUrlProtocolComponentModule,
  buttonComponentModule,
  formDataComponentModule,
  formGroupComponentModule,
  inputGroupRequiredComponentModule,
  loginVerificationComponentModule,
  markValidationComponentModule,
  multilinePlaceholderComponentModule,
  phoneNumberValidatorComponentModule,
  scrollToErrorComponentModule,
  selectComponentModule,
  serverValidationErrorsComponentModule,
  stopRouteChangeIfInvalidComponentModule,
  tagsInputTabindexComponentModule,
  uniqueEmailValidatorComponentModule,
  warnOnChangesComponentModule,
  autocompleteFixesComponentModule,
]);
